import React, { memo, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Skeleton } from '@mui/material';
import withLoading, { WithLoadingPropTypes } from 'hocs/withLoading';
import PropTypes from 'prop-types';
import { compose } from 'redux';

import { useEffectSafeStrictMode } from 'hooks/useEffectSafeStrictMode';

import { getWarehouseBanksAction } from 'store/accounting/actions';
import { getDenialReasonsAction, getLoanActionPossibleFieldsAction } from 'store/system/actions';

import LoanActionModalForm from './LoanActionModalForm';

const LoanActionModal = ({
  actionId,
  variableFields,
  setIsLoading,
  isLoading,
  onFormSubmit,
  formRef,
}) => {
  const dispatch = useDispatch();
  const [isLoanActionDataLoaded, setIsLoanActionDataLoaded] = useState(false);

  useEffectSafeStrictMode(() => {
    setIsLoading(true);

    Promise.all([
      dispatch(getLoanActionPossibleFieldsAction()),
      dispatch(getDenialReasonsAction()),
      dispatch(getWarehouseBanksAction()),
    ])
      .catch(Error)
      .finally(() => {
        setIsLoading(false);
        setIsLoanActionDataLoaded(true);
      });
  }, [dispatch, setIsLoading, setIsLoanActionDataLoaded]);

  if (!isLoanActionDataLoaded) {
    return (
      <div className="flex flex-col items-stretch p-24 w-full min-w-400">
        {variableFields.map((__, i) => (
          <Skeleton
            animation="pulse"
            className="h-52 m-8 mb-28 rounded-4"
            key={i}
            variant="rectangular"
          />
        ))}
      </div>
    );
  }

  return (
    <LoanActionModalForm
      actionId={actionId}
      formRef={formRef}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      variableFields={variableFields}
      onFormSubmit={onFormSubmit}
    />
  );
};

LoanActionModal.propTypes = {
  ...WithLoadingPropTypes,
  actionId: PropTypes.string.isRequired,
  formRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
  variableFields: PropTypes.array.isRequired,
  onFormSubmit: PropTypes.func.isRequired,
};

export default compose(withLoading, memo)(LoanActionModal);
